import {
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  HostBinding,
  QueryList,
} from '@angular/core';
import { BreadcrumbsItemDirective } from './breadcrumbs-item.directive';

@Component({
    selector: 'lui-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BreadcrumbsComponent {
  @HostBinding('class') hostClass = 'lui-breadcrumbs';

  @ContentChildren(BreadcrumbsItemDirective)
  items!: QueryList<BreadcrumbsItemDirective>;
}
